export function setAddresses (state, direcciones) {
  state.direcciones = direcciones
}

export function setAddress (state, direccion) {
  state.direccionSeleccionada = direccion
}

export function updateAddressStatus (state, payload) {
  const address = state.direcciones.find(t => t.Id === payload.Id)
  if (address) {
    address.default = !address.default
  }
}

export function errorMessage (state, payload) {
  state.error = true
  state.errorMessage = payload
  state.todos = []
}
